import React from 'react';
import cn from 'clsx';
import { Dropdown, DropdownItem, DropdownProps, ThemeProvider } from 'fronton-react';
import { css } from 'linaria';

const warningStyle = css`
  border-radius: var(--rounding-m);
  box-shadow: 0 0 0 2px var(--secondary-yellow-primary);
`;

export type DropdownOption = {
  text: string;
  value: string;
};

type SelectProps = {
  options: DropdownOption[];
  warning?: boolean;
  error?: boolean;
} & DropdownProps;

/**
 * Компонент выпадающего списка
 */
export const Select: React.FC<SelectProps> = ({ className, options, size = 'l', warning, ...rest }) => (
  <ThemeProvider>
    <Dropdown
      className={cn(className, { [warningStyle]: warning })}
      closeOnSelect
      size={size}
      {...(rest as DropdownOption)}>
      {options.map(({ text, value }: DropdownOption) => (
        <DropdownItem key={value} text={text} value={value} />
      ))}
    </Dropdown>
  </ThemeProvider>
);
